import React from 'react';
import { Hero } from './components/Hero';
import { ForWhom } from './components/ForWhom';
import { Modules } from './components/Modules';
import { QuoteBanner } from './components/QuoteBanner';
import { Bonuses } from './components/Bonuses';
import { ProgramNumbers } from './components/ProgramNumbers';
import { WhyItWorks } from './components/WhyItWorks';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="2mm2m8fvmev3y">
      <Hero data-id="element-1" data-mp="2mnnhk7prei2v" />
      <main data-id="element-2" data-mp="2mjpwvhnj9igv">
        <ForWhom data-id="element-3" data-mp="31aqeac69cmp5" />
        <Modules data-id="element-4" data-mp="31b8jhyaweb97" />
        <QuoteBanner data-id="element-5" data-mp="31bs2licab5ot" />
        <Bonuses data-id="element-6" data-mp="31c9ts0k3atpv" />
        <ProgramNumbers data-id="element-7" data-mp="31ctfztgrw49p" />
        <WhyItWorks data-id="element-8" data-mp="2wka0us2ft12s" />
        <FinalCta data-id="element-9" data-mp="2wjqgl4pbe0ll" />
      </main>
      <Footer data-id="element-10" data-mp="2wifhhi6tdh0t" />
    </div>;
}